import { z } from 'zod'

export const JobCalendarRequestSchema = z.object({
  job_id: z.string().describe('Unique job identifier'),
  event_id: z
    .string()
    .optional()
    .describe('Google Calendar event ID for updates/deletes'),
  title: z
    .string()
    .optional()
    .describe('Event title (required for create/update)'),
  description: z
    .string()
    .optional()
    .describe('Event description with job details'),
  location: z.string().optional().describe('Job site address'),
  start_date: z
    .string()
    .datetime()
    .optional()
    .describe('Event start date and time (required for create/update)'),
  end_date: z
    .string()
    .datetime()
    .optional()
    .describe('Event end date and time (required for create/update)'),
  email_addresses: z
    .array(z.string().email())
    .optional()
    .describe(
      'List of email addresses to add as attendees when creating/updating event'
    ),
})

export const JobCalendarResponseSchema = z.object({
  success: z.boolean().describe('Whether the operation was successful'),
  event_id: z
    .string()
    .optional()
    .nullable()
    .describe('Google Calendar event ID (returned on create)'),
  event_link: z
    .string()
    .optional()
    .nullable()
    .describe('Direct link to view the event in Google Calendar'),
  message: z.string().optional().nullable().describe('Optional status message'),
  error: z.string().optional().nullable().describe('Optional error details'),
})

export const CalendarAttendeeRequestSchema = z.object({
  event_id: z.string().describe('Google Calendar event ID'),
  email_addresses: z
    .array(z.string().email())
    .describe('List of email addresses to add/remove as attendees'),
})

export const CalendarAttendeeResponseSchema = z.object({
  success: z.boolean().describe('Whether the operation was successful'),
  event_id: z.string().describe('Google Calendar event ID'),
  processed_emails: z
    .array(z.string())
    .describe('Email addresses that were successfully processed'),
  failed_emails: z
    .array(z.string())
    .describe('Email addresses that failed to process'),
  message: z.string().optional().nullable().describe('Optional status message'),
  error: z.string().optional().nullable().describe('Optional error details'),
})

export type JobCalendarRequest = z.infer<typeof JobCalendarRequestSchema>
export type JobCalendarResponse = z.infer<typeof JobCalendarResponseSchema>
export type CalendarAttendeeRequest = z.infer<
  typeof CalendarAttendeeRequestSchema
>
export type CalendarAttendeeResponse = z.infer<
  typeof CalendarAttendeeResponseSchema
>
